import { auth } from '@/helpers/firebase/firebase';

export async function getAuthHeaders(): Promise<Record<string, string>> {
  const user = auth.currentUser;
  if (!user) throw new Error('Not authenticated');

  const token = await user.getIdToken();
  return { Authorization: `Bearer ${token}` };
}

export async function fetchAuthedJson<T = unknown>(path: string, init?: RequestInit): Promise<T> {
  const headers = await getAuthHeaders();
  const response = await fetch(path, {
    ...(init || {}),
    headers: {
      ...(init?.headers || {}),
      ...headers,
    },
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || `Request failed (${response.status})`);
  }

  return (await response.json()) as T;
}
